import { createSlice } from "@reduxjs/toolkit";
import updateMicroscopyMeasurements from '../../../rtk-apis/microscopy/updateMeasurements'

const initialState = {
  status: "",
  result: [],
  message: "",
  loading: false,
  error: ""
};

const updateMicroscopyMeasurementsSlice = createSlice({
  name: "patientMicroscopicData",
  initialState,
  reducers: {
    resetStatus(state: any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateMicroscopyMeasurements.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(updateMicroscopyMeasurements.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(updateMicroscopyMeasurements.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default updateMicroscopyMeasurementsSlice.reducer;
export const { resetStatus } = updateMicroscopyMeasurementsSlice.actions;
